/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filename_LabelInputs */

const en_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filename`)
};

const fr_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de fichier`)
};

const de_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiname`)
};

const it_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del file`)
};

const ru_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя файла`)
};

const es_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo`)
};

const zh_cn2_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件名`)
};

const ja_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名`)
};

const hi_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइलनाम`)
};

const pt_pt2_manual_qc_filename_label = /** @type {(inputs: Manual_Qc_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo`)
};

/**
* | output |
* | --- |
* | "Filename" |
*
* @param {Manual_Qc_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filename_label = /** @type {((inputs?: Manual_Qc_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_filename_label(inputs)
	if (locale === "de") return de_manual_qc_filename_label(inputs)
	if (locale === "it") return it_manual_qc_filename_label(inputs)
	if (locale === "ru") return ru_manual_qc_filename_label(inputs)
	if (locale === "es") return es_manual_qc_filename_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_filename_label(inputs)
	if (locale === "ja") return ja_manual_qc_filename_label(inputs)
	if (locale === "hi") return hi_manual_qc_filename_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_filename_label(inputs)
	return en_manual_qc_filename_label(inputs)
});